export default {
  name: 'bridge-my-learning-legacy',
  cdn: {
    edge: 'https://d1h1778jwn2brc.cloudfront.net',
    staging: 'https://d2wzd4gs88w14e.cloudfront.net',
    production: 'https://d3fuoknb3jgind.cloudfront.net',
  },
  pathPatterns: [/^\/learner\b/],
  stylesheets: [
    'stylesheets_main_external_css',

    // application and module specific styles need to be loaded after framework
    // styles for now because we can't rely on proper specificity right now and
    // external component styles will clash with legacy styles
    'stylesheets_application_css',
    'stylesheets_my_learning_shared_modules_css',
    'stylesheets_my_learning_css',
    'stylesheets_my_learning_my_learning_modules_css',
    'stylesheets_my_learning_my_learning_sass_modules_css',
  ],
  scripts: ['javascripts_my_learning_js'],
  disabledNavPaths: [
    /^\/learner\/approver\/checkpoint/,
    /^\/learner\/checkpoints\/\d+/,
    /^\/learner\/courses\/\d+\/finished/,
    /^\/learner\/courses\/\d+\/slide/,
    /^\/learner\/programs\/\d+/,
    /^\/learner\/programs\/\w+\/preview/,
    /^\/learner\/surveys\/\d+/,
  ],
};



// WEBPACK FOOTER //
// ./jsapp/my-learning/learn-runtime.js